export default __webpack_public_path__ + "static/media/profile_av.49e8d56b.jpg";